import { Component } from '@angular/core';


@Component({
    selector: 'soft-time-picker',
    imports: [],
    templateUrl: './time-picker.component.html',
    styleUrl: './time-picker.component.css'
})
export class TimePickerComponent {}
